<template>
  <v-dialog v-model="show" persistent width="300">
    <v-card color="primary" dark>
      <v-card-text>
        {{ message }}
        <v-progress-linear
          indeterminate
          color="white"
          class="mb-0"
        ></v-progress-linear>
        <v-row v-if="debug">
          <v-col>
            <code>{{ value }}</code>
          </v-col>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>
<script>
import TaskStatusMixin from "../../../mixins/TaskStatusMixin";
export default {
  name: "task-status",

  props: {
    show: {
      type: Boolean,
      default: () => false,
    },
    value: {
      type: Object,
      default: () => null,
    },
  },

  mixins: [TaskStatusMixin],

  data() {
    return {
      debug: false,
      message: "In progress...",
      taskID: this.value ? this.value.id : "",
    };
  },

  watch: {
    show(show) {
      if (show && this.taskID != "") {
        this.checkStatus = true;
      }
    },
    value(newVal) {
      this.taskID = newVal.id;
      if (this.taskID != "") {
        this.checkStatus = true;
      }
    },
  },

  methods: {
    taskStatusCompleteHandler(data) {
      this.$emit("complete", data);
    },
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/gt/shared/TaskStatus.vue